module.exports = __webpack_public_path__ + "img/icon_tese_wending@2x.f005bee3.png";